import type { ReactNode } from 'react';
import type { WebsocketAwarenessState } from '../../hooks/useWebsocket/websocket';

import { twMerge } from 'tailwind-merge';

import { getUniqueEditors } from '../../form-hooks/lib/helpers';

import useDarkMode from '../../hooks/useDarkMode';

const xAxisPositioning = {
  center: 'left-1/2 mb-0.5',
  right: 'right-4',
};

const FieldEditorsIndicator = ({
  editors,
  children,
  borderRadius = 8,
  position = 'right',
}: {
  editors?: WebsocketAwarenessState[];
  children: ReactNode;
  borderRadius?: number;
  position?: keyof typeof xAxisPositioning;
}) => {
  const [darkMode] = useDarkMode();

  const uniqueEditors = getUniqueEditors(editors);

  return (
    <div
      className={twMerge(
        'relative h-fit group/field-editor',
        uniqueEditors?.length ? 'outline-1' : '',
      )}
      style={
        darkMode
          ? { outlineColor: uniqueEditors[0]?.lightColor, borderRadius }
          : { outlineColor: uniqueEditors[0]?.color, borderRadius }
      }
    >
      <div
        className={twMerge(
          'absolute bottom-full flex gap-2 whitespace-nowrap',
          'opacity-0 invisible group-hover/field-editor:visible group-hover/field-editor:opacity-100',
          xAxisPositioning[position],
        )}
      >
        {uniqueEditors.map((editor) => (
          <div
            key={editor.userId}
            className={
              'rounded-md rounded-bl-none px-3 py-0.5 font-medium z-10 w-full' +
              'transition-opacity duration-200'
            }
            style={
              darkMode
                ? { backgroundColor: editor.lightColor, color: '#000' }
                : { backgroundColor: editor.color, color: '#fff' }
            }
          >
            {editor.name}
          </div>
        ))}
      </div>

      {children}
    </div>
  );
};

export default FieldEditorsIndicator;
